import * as React from "react";
import type { IOrchestrators } from "./fetchOrchestrators";

type NoUndefinedField<T> = {
  [P in keyof T]-?: NoUndefinedField<NonNullable<T[P]>>;
};

export const OrchestratorsContext =
  // eslint-disable-next-line unicorn/no-null
  React.createContext<IOrchestrators | null>(null);

type IType = keyof IOrchestrators;

interface IOptions {
  isOptional: true;
}

export function useOrchestrators(): IOrchestrators;
export function useOrchestrators<T extends IType>(
  type: T,
): NoUndefinedField<IOrchestrators>[T];
export function useOrchestrators<T extends IType>(
  type: T,
  options: IOptions,
): IOrchestrators[T];
export function useOrchestrators<T extends IType>(
  type?: T,
  options?: IOptions,
) {
  const value = React.useContext(OrchestratorsContext);

  if (value === null) {
    throw new Error("`Missing RespectOrchestratorState` in tree.");
  }

  if (type) {
    const orchestrator = value[type];

    if (!options && !orchestrator) {
      throw new Error(`Orchestrator ${type} is missing, but set as Required.`);
    }

    return orchestrator;
  }

  return value;
}
